import http from '@/helpers/Http';

export default {
    namespaced: true,
    state: {
        items: {
            data: [],
            links: {},
            meta: {},
        }
    },
    getters: {
        items: state => state.items,
    },
    mutations: {
        setItems(state, items) {
            state.items = items;
        }
    },
    actions: {
        async index({ commit, rootState }) {
            const response = await http.get('postfix/aliases', {params: rootState.route.query});

            commit('setItems', response.data);

            return response;
        },
        async store({ commit }, payload) {
            const response = await http.post('postfix/aliases', payload);

            return response;
        },
        async update({ commit }, payload) {
            const response = await http.patch(`postfix/aliases/${payload.address}`, payload);

            return response;
        },
        async activate({ commit }, id) {
            const response = await http.patch(`postfix/aliases/${id}/activate`);

            return response;
        },
        async deactivate({ commit }, id) {
            const response = await http.patch(`postfix/aliases/${id}/deactivate`);

            return response;
        },
        async delete({ commit }, id) {
            const response = await http.delete(`postfix/aliases/${id}`);

            return response;
        }
    }
}